module.exports = __webpack_public_path__ + "798bee49aa49fbe4eb65c94a5cc5e286.png";